import type { ReactElement } from "react";

import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";
import { Stack } from "@similarweb/ui-components/foundations";

import SignalsSegmentedSignalData from "./SignalsSegmentedSignalData";
import SignalsSegmentedSignalType from "./SignalsSegmentedSignalType";

type Props = {
    uiSignal: Omit<UISignal<SignalFilters>, "nameSegments"> & Required<Pick<UISignal<SignalFilters>, "nameSegments">>;
};

const SignalsSegmentedName = ({ uiSignal }: Props): ReactElement => {
    const { nameSegments, selectionTooltipLabels } = uiSignal;

    return (
        <Stack gap="6px">
            <SignalsSegmentedSignalType
                signalType={nameSegments.signalType}
                selectionOverflowOn={nameSegments.selectionOverflowOn}
                selectionTooltipLabels={selectionTooltipLabels}
            />
            <SignalsSegmentedSignalData
                signalData={nameSegments.signalData}
                selectionOverflowOn={nameSegments.selectionOverflowOn}
                selectionTooltipLabels={selectionTooltipLabels}
            />
        </Stack>
    );
};

export default SignalsSegmentedName;
